export enum UserRoles {
  Standard = 1,
  Super = 2,
  Admin = 3
}